<div class="ps-card ps-gauge-card">
  <div class="ps-card-header">
    <div class="ps-card-heading">
      <span class="ps-card-icon"><ps-outline-icon name="target"></ps-outline-icon></span>
      <div>
        <h2 class="ps-card-kicker">Execution</h2>
        <p class="ps-card-sub">Execution vs plan and key milestones</p>
      </div>
    </div>
    <div class="ps-card-actions">
      <button class="ps-icon-btn" title="Schedule Details" (click)="drilldownExecution()">
        <ps-outline-icon name="clipboard"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Time Entry" (click)="launchTimeEntry()">
        <ps-outline-icon name="clock"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Status Report" (click)="primaveraStatusReport()">
        <ps-outline-icon name="cloud-download"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Detailed Reports" (click)="openP6Reporting()"
        [disabled]="openingP6Reporting">
        <ps-outline-icon name="chart-line"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Ask the data" (click)="openAskData()">
        <ps-outline-icon name="lightbulb"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Blind Faith Tar Report" (click)="chevronBlindFaithTARReport()"
        *ngIf="canShowTarReportButton">
        <ps-outline-icon name="cloud-download"></ps-outline-icon>
      </button>
    </div>
  </div>

  <summary-gauge [percent]="executionOverallComplete || 0" [display]="displayPercent" [statusLabel]="status.label"
    [badgeClass]="status.badgeClass" [gaugeColor]="status.gaugeColor"
    [isActive]="isActive" [playToken]="playToken"></summary-gauge>

  <div class="ps-date-grid">
    <div class="ps-date-cell">
      <ps-outline-icon name="calendar"></ps-outline-icon>
      <div>
        <div class="ps-date-label">Date</div>
        <div class="ps-date-value">{{ displayDate(projectDataDate) }}</div>
      </div>
    </div>
    <div class="ps-date-cell">
      <ps-outline-icon name="flag"></ps-outline-icon>
      <div>
        <div class="ps-date-label">Baseline</div>
        <div class="ps-date-value">{{ displayDate(baselineTargetFinish) }}</div>
      </div>
    </div>
    <div class="ps-date-cell">
      <ps-outline-icon name="clock"></ps-outline-icon>
      <div>
        <div class="ps-date-label">Projected</div>
        <div class="ps-date-value">{{ displayDate(projectTargetFinish) }}</div>
      </div>
    </div>
  </div>
</div>

<div class="ps-card" *ngIf="showPercentRollups">
  <button type="button" class="ps-section-title ps-section-toggle" [class.is-collapsed]="!isPercentCompleteExpanded"
    (click)="togglePercentComplete()" [attr.aria-expanded]="isPercentCompleteExpanded">
    <span class="ps-section-toggle-left">
      <ps-outline-icon [name]="isPercentCompleteExpanded ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span>Percent Complete</span>
    </span>
    <span class="ps-section-toggle-pct" *ngIf="!isPercentCompleteExpanded">{{ formatPct(executionOverallComplete) }}</span>
  </button>

  <div class="ps-section-content" *ngIf="isPercentCompleteExpanded">
    <div class="ps-pct-row">
      <div class="ps-pct-label">Total Actual Percent Complete</div>
      <div class="ps-pct-track">
        <div class="ps-bar is-actual" [class.ps-run]="true">
          <span [style.width]="barWidth(executionOverallComplete) + '%'"></span>
        </div>
        <div class="ps-pct-value">{{ formatPct(executionOverallComplete) }}</div>
      </div>
    </div>

    <div class="ps-pct-row">
      <div class="ps-pct-label">Total Planned Percent Complete</div>
      <div class="ps-pct-track">
        <div class="ps-bar is-planned" [class.ps-run]="true">
          <span [style.width]="barWidth(executionPlannedCompleteWidth) + '%'"></span>
        </div>
        <div class="ps-pct-value">{{ formatPct(executionPlannedComplete) }}</div>
      </div>
    </div>

    <div class="ps-pct-row" *ngIf="project?.ShowProjected">
      <div class="ps-pct-label">Total Projected Percent Complete</div>
      <div class="ps-pct-track">
        <div class="ps-bar is-projected" [class.ps-run]="true">
          <span [style.width]="barWidth(executionProjectedPercentWidth) + '%'"></span>
        </div>
        <div class="ps-pct-value">{{ formatPct(executionProjectedPercent) }}</div>
      </div>
    </div>
  </div>
</div>

<div class="ps-card ps-wbs-card" *ngIf="wbsLevels.length">
  <button type="button" class="ps-section-title ps-section-toggle" [class.is-collapsed]="!isWbsExpanded"
    (click)="toggleWbs()" [attr.aria-expanded]="isWbsExpanded">
    <span class="ps-section-toggle-left">
      <ps-outline-icon [name]="isWbsExpanded ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span>Unit / Duration Progress</span>
    </span>
  </button>
  <div class="ps-section-content" *ngIf="isWbsExpanded">
    <project-execution-stage class="ps-wbs-stage rollups"
      *ngFor="let stage of wbsLevels"
      [stage]="stage"
      [project]="project"></project-execution-stage>
  </div>
</div>

<div class="ps-card ps-timeline-card">
  <button type="button" class="ps-section-title ps-section-toggle" [class.is-collapsed]="!isTimelineExpanded"
    (click)="toggleTimeline()" [attr.aria-expanded]="isTimelineExpanded">
    <span class="ps-section-toggle-left">
      <ps-outline-icon [name]="isTimelineExpanded ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span>Execution Timeline</span>
    </span>
  </button>
  <div class="ps-section-content" *ngIf="isTimelineExpanded">
    <div class="ps-timeline">
      <div class="ps-timeline-item">
        <span class="ps-timeline-node is-icon">
          <ps-outline-icon name="calendar"></ps-outline-icon>
        </span>
        <span class="ps-timeline-tick" aria-hidden="true"></span>
        <div class="ps-timeline-label">Project Date</div>
        <div class="ps-timeline-value">{{ displayDate(projectDataDate) }}</div>
      </div>
      <div class="ps-timeline-item">
        <span class="ps-timeline-node is-dot"></span>
        <span class="ps-timeline-tick" aria-hidden="true"></span>
        <div class="ps-timeline-label">Baseline</div>
        <div class="ps-timeline-value">{{ displayDate(baselineTargetFinish) }}</div>
      </div>
      <div class="ps-timeline-item">
        <span class="ps-timeline-node is-icon">
          <ps-outline-icon name="clock"></ps-outline-icon>
        </span>
        <span class="ps-timeline-tick" aria-hidden="true"></span>
        <div class="ps-timeline-label">Projected Completion</div>
        <div class="ps-timeline-value">{{ displayDate(projectTargetFinish) }}</div>
      </div>
    </div>
    <button type="button" class="ps-link" *ngIf="showChart('scurve')" (click)="openSCurve()">View schedule</button>
    <button type="button" class="ps-link" *ngIf="powerBiReportPath" (click)="powerBiReport()">Power BI Report</button>
  </div>
</div>
